<template>
  <div class="crumb">
    <a :href="baseUrl" title="ETF專區">ETF專區</a>
    &gt;
    <template v-if="lv1 && lv1.length > 0">
      <router-link :to="{ name: lv1RouteName }" :title="lv1">
        {{ lv1 }}
      </router-link>
      &gt;
    </template>
    <template v-if="lv2 && lv2.length > 0">
      <router-link :to="{ name: lv2RouteName }" :title="lv2">
        {{ lv2 }}
      </router-link>
      &gt;
    </template>
    <template v-if="lv3 && lv3.length > 0">
      <router-link :to="{ name: lv3RouteName }" :title="lv3">
        {{ lv3 }}
      </router-link>
      &gt;
    </template>
    <span class="crumb-now">{{ now }}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseUrl: process.env.BASE_URL // undefined
    }
  },
  props: {
    lv1: String,
    lv1Url: { type: String, default: process.env.BASE_URL },
    lv1RouteName: { type: String, default: 'LandingPage' },

    lv2: String,
    lv2Url: { type: String, default: process.env.BASE_URL },
    lv2RouteName: { type: String, default: 'LandingPage' },

    lv3: String,
    lv3Url: { type: String, default: process.env.BASE_URL },
    lv3RouteName: { type: String, default: 'LandingPage' },

    now: { type: String, required: true }
  }
}
</script>
